export default __webpack_public_path__ + "static/media/Crossword.7c28e07b.svg";